import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FacilityModal from './FacilityModal';

const API_URL = '/api';

function FacilitiesPage({ token }) {
  const [facilities, setFacilities] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingFacility, setEditingFacility] = useState(null);

  useEffect(() => {
    loadFacilities();
  }, []);

  const loadFacilities = async () => {
    try {
      const response = await axios.get(`${API_URL}/facilities`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFacilities(response.data);
    } catch (err) {
      console.error('Tesisler yüklenemedi:', err);
    }
  };

  const deleteFacility = async (id) => {
    if (!window.confirm('Bu tesisi silmek istediğinizden emin misiniz?')) return;
    
    try {
      await axios.delete(`${API_URL}/facilities/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Tesis silindi');
      loadFacilities();
    } catch (err) {
      alert('Hata: ' + err.response?.data?.error);
    }
  };

  return (
    <div className="admin-page">
      <div className="card">
        <h3>
          🏭 Tesis Yönetimi
          <button onClick={() => setShowAddModal(true)} className="btn-add">
            + Yeni Tesis
          </button>
        </h3>

        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Tesis Adı</th>
                <th>Açıklama</th>
                <th>Konum</th>
                <th>Koordinatlar</th>
                <th>Alan (m²)</th>
                <th>Durum</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {facilities.map(facility => (
                <tr key={facility._id}>
                  <td><strong>{facility.facilityName}</strong></td>
                  <td>{facility.description}</td>
                  <td>{facility.location?.address}</td>
                  <td>
                    {facility.location?.coordinates?.lat?.toFixed(4)}, {facility.location?.coordinates?.lon?.toFixed(4)}
                  </td>
                  <td>{facility.totalArea?.toLocaleString()}</td>
                  <td>
                    <span className={`status-badge ${facility.isActive ? 'status-active' : 'status-inactive'}`}>
                      {facility.isActive ? '✓ Aktif' : '✗ Pasif'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button 
                        className="btn-edit"
                        onClick={() => setEditingFacility(facility)}
                      >
                        ✏️
                      </button>
                      <button 
                        className="btn-delete"
                        onClick={() => deleteFacility(facility._id)}
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {(showAddModal || editingFacility) && (
        <FacilityModal
          facility={editingFacility}
          token={token}
          onClose={() => {
            setShowAddModal(false);
            setEditingFacility(null);
          }}
          onSuccess={() => {
            setShowAddModal(false);
            setEditingFacility(null);
            loadFacilities();
          }}
        />
      )}
    </div>
  );
}

export default FacilitiesPage;
